(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-faq"]) return;
  try {
    

$(document).ready(function() {
    $('.accordion__item').each(function(index){
        $(this).find('.accordion-body__contents').slideToggle(300);
    });

    $('.accordion-header').on('click', function(){
        let position = $(this).parent().index();
        let closePosition = 0;

        $('.accordion__item').each(function(index){
            if($(this).hasClass('active')) {
                $(this).removeClass('active');
                $('.accordion__item').eq(index).find('.accordion-body__contents').slideToggle(200);
                if(position == index) { return; }
            }

            if(position == index) {
                $(this).addClass('active');
                $('.accordion__item').eq(index).find('.accordion-body__contents').slideToggle(400);
                return;
            }
        });
    });
});

  } catch(e) { console.error(e); }
})();

})();
